import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { mutations } from './mutations';
import { actions } from './actions';
import { NpsState } from './types';

export * from './types';

export const initialState: NpsState = {
  nps: undefined,
};

export const npsModule: Module<NpsState, RootState> = {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};

export default npsModule;
